import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=61aa5e1e&"
import script from "./OpenApp.vue?vue&type=script&lang=js&"
export * from "./OpenApp.vue?vue&type=script&lang=js&"
import style0 from "./OpenApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports